import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { VerificaDocumentiCaricatiComponent } from './verifica-documenti-caricati';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.verifica-documenti-caricati', {
            url: '/verifica-documenti-caricati/:classeDocumentale',
            params: {
                classeDocumentale: ''
            },
            ncyBreadcrumb: {
                label: 'Verifica Documenti Caricati',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Verifica Documenti Caricati'
            },
            'views': {
                'homeContent': {
                    template: '<verifica-documenti-caricati flex="100"></verifica-documenti-caricati>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const VerificaDocumentiCaricatiModule: string = ng
    .module('verifica-documenti-caricati', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('verificaDocumentiCaricati', VerificaDocumentiCaricatiComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/verifica-documenti-caricati/verifica-documenti-caricati.module.ts